<template>
  <div class="page" @touchmove.prevent>
    <div class="bg-window"></div>
    <div class="main">
      <!-- <div class="about-me">关于我</div> -->
      <img class="pic-about-me" src="https://static.huiyiji520.com/cppic-1661154078.png">
      <!-- <div class="hint">你的年龄？</div> -->
      <img class="pic-hint" src="https://static.huiyiji520.com/cppic-1661159793.png">
      <div class="input-birth" @click="showDatePickerPop()">{{ !age ? "选择年龄" : age }}</div>
      <van-datetime-picker
        class="datepicker"
        v-if="showDatePicker"
        v-model="currentDate"
        type="date"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="confirmDatePickerPop()"
        @cancel="hideDatePickerPop()"
      />
      <div class="arrows">
        <div class="signs flex-box">
          <!-- <div class="prev" @click="goBack()"><van-icon name="arrow-left" color="#eb8e80" />上一步</div>
          <div class="next" @click="goNext()">下一步<van-icon name="arrow" color="#eb8e80" /></div> -->
          <img class="pic-prev" @click="goBack()" src="https://static.huiyiji520.com/cppic-1661159773.png">
          <img class="pic-next" @click="goNext()" src="https://static.huiyiji520.com/cppic-1661157292.png">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Icon, DatetimePicker } from 'vant'

export default{
  components: {
    [Toast.name]: Toast,
    [Icon.name]: Icon,
    [DatetimePicker.name]: DatetimePicker
  },
  data(){
    return {
      age: '',
      birth: '',
      minDate: new Date(1970, 0, 1),
      maxDate: new Date(2024, 11, 30),
      currentDate: new Date(2010, 0, 1),
      showDatePicker: false
    }
  },
  methods: {
    handleRouter(path){
      this.$router.push(path)
    },
    goBack(){
      this.$router.back()
    },
    goNext(){
      if(!this.age){
        Toast('请选择你的年龄')
      }else if(this.age < 18){
        Toast('须年满18周岁才可参与本活动')
      }else{
        let cpchoose = this.$store.state.cpchoose
        cpchoose.myBirth = this.birth
        this.$store.commit('updateCpChoose', cpchoose)
        this.handleRouter('/choose_me_city')
      }
    },
    showDatePickerPop(){
      this.showDatePicker = true
    },
    hideDatePickerPop(){
      this.showDatePicker = false
    },
    confirmDatePickerPop(){
      this.showDatePicker = false
      let year = this.currentDate.getFullYear()
      this.age = 2026 - year
      this.birth = `${this.currentDate.getFullYear()}-${this.currentDate.getMonth() + 1}-${this.currentDate.getDate()}`
    },
    recoverBirth(){
      this.birth = this.$store.state.cpchoose.myBirth ? this.$store.state.cpchoose.myBirth : this.birth
      this.age = this.birth ? (2026 - parseInt(this.birth.split("-")[0])) : this.age
    }
  },
  mounted(){
    this.recoverBirth()
    this.$report.submit('/choose_me_age', this.$store.state.issue, this.$store.state.userinfo.openid)
  }
}
</script>

<style scoped>
.page{min-height:100vh;}
.bg-window{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-image: url("https://static.huiyiji520.com/cppic-1661155471.png");
  background-size:100% 100%;
  background-repeat:no-repeat;
  /* opacity:0.1; */
  z-index:-1;
}
.main{text-align:center;}
.main .about-me{margin-top:200px;margin-bottom:134px;font-size:70px;color:#eb8e80;}
.main .hint{font-size:40px;line-height:40px;color:#eb8e80;margin-bottom:160px;}
.main .pic-about-me{width:206px;height:68px;margin:0 auto;margin-top:208px;margin-bottom:146px;}
.main .pic-hint{width:228px;height:42px;margin:0 auto;margin-bottom:160px;}
.main .input-birth{
  font-size:40px;color:#eb8e80;width:340px;
  background:#fff;border:1px dashed #eb8e80;height:86px;line-height:86px;margin:0px auto;
}
.main .arrows{position:fixed;bottom:120px;width:100%;}
.main .arrows .signs{
  justify-content:space-between;padding:0px 194px;
  font-size:32px;color:#eb8e80;
}
.main .pic-prev{width:120px;height:32px;}
.main .pic-next{width:120px;height:32px;}
.main .datepicker{z-index:100;}
</style>
